module.exports = __webpack_public_path__ + "static/fonts/GodoM.d810981.ttf";